/**
 * OnboardingProgressBar - Chapter indicator with progress dots
 *
 * Shows the current chapter name and a visual progress bar
 * indicating position within the overall tour.
 */

import React from 'react';
import { useTranslation } from '@/contexts/LanguageContext';

interface OnboardingProgressBarProps {
  chapterTitleKey: string;
  chapterIndex: number;
  totalChapters: number;
  globalStepIndex: number;
  totalSteps: number;
}

const OnboardingProgressBar: React.FC<OnboardingProgressBarProps> = ({
  chapterTitleKey,
  chapterIndex,
  totalChapters,
  globalStepIndex,
  totalSteps,
}) => {
  const { t } = useTranslation();
  const progressPercent = totalSteps > 1 ? (globalStepIndex / (totalSteps - 1)) * 100 : 0;

  return (
    <div className="space-y-2">
      {/* Chapter label + counter */}
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-primary uppercase tracking-wide">
          {t(chapterTitleKey)}
        </span>
        <span className="text-xs text-muted-foreground">
          {chapterIndex + 1}/{totalChapters}
        </span>
      </div>

      {/* Progress bar */}
      <div className="h-1 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary rounded-full transition-all duration-300 ease-out"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
};

export default OnboardingProgressBar;
